import { useContext } from "react";
import { ModalLoadingContext } from "libs/context/ModalLoadingContext";

function useModalLoading() {
  return useContext(ModalLoadingContext);
}

export default useModalLoading;
